<template>
  <div class="d-center autocomplete">
    <span v-if="leftText" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="d-center" v-if="leftText"><div class="form-left-text" :style="{width:width+'px'}">{{leftText}}</div>：</div>
    <div class="w-100  input-self" v-if="type!=='textarea'" style="text-align:left;">
        <el-autocomplete
        popper-class="my-autocomplete"
        v-model="localStoreName"
        :placeholder="placeholder?leftText:''"
        :fetch-suggestions="querySearchAsync"
        :trigger-on-focus="false"
        @select="handleSelect"
        class="w-100"
        >
            <template slot-scope="{ item }">
              <!-- v-html 必须用，渲染包裹的span标签 -->
              <span v-html="$verify.highlightKeyword(item.title, localStoreName)"></span>
            </template>
        </el-autocomplete>
    </div>
  </div> 
</template>

<script>
import {mapActions} from 'vuex'
export default {
    name: 'LeftTextAutocomplete',
    components: {},
    props: {
      placeholder: {
        type: Boolean,
        default: true
      },
      value: {
        type: String,
        default: ''
      },
       width: {
        type: Number,
        default:100
      },
      storeType:{
        type: Number,
        default:0
      },
      type: {
        type: String,
        default: 'text'
      },
      leftText: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default() {
          return [];
        }
      },
      adminsearch:{
        type: Boolean,
        default: false
      },
    },
    data() {
        return {
            localStoreName: '',
        };
    },
    computed: {},
      watch: {
        // 监听输入框值：实时同步给父组件（包括空值）
        localStoreName(newVal) {
          let val = (newVal || '').trim()
          // 赋值回输入框（避免空格显示）
          this.localStoreName = val
          this.$emit('input', val);
      },
      value(newVal) {
        this.localStoreName = newVal;
      }
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions(['POST_SearchDocHotel','POST_GetAllCity']),
        //搜索框的建议列表
        async querySearchAsync(queryString, cb) {
            //内容不等于空字符串
            if (queryString.trim() === '') {
              cb([]);
              return;
            };
            let res= await this.POST_SearchDocHotel({data:{title: queryString,storeType:this.storeType},adminsearch:this.adminsearch})
            this.timeout = setTimeout(() => {
            cb(res.list);
            }, 2000 * Math.random());
        },
        //点击搜索框的建议项
        handleSelect(item) {
          this.$emit('input',item.title);
          this.localStoreName = item.title;
        },
    }
};
</script>

<style lang="scss" scoped>
  .narrow{
    input{
      height: 24px!important;
    }
  }
  .smallInput{
    height: 24px!important;
    line-height: 24px!important
  }
  .input-self-border {
    width: 100%;
    box-sizing: border-box;
    color: #606266;
    flex: 1;
    input,textarea{
      border: 1px solid #dcdfe6;
      padding: 3px 0px;
      appearance: none;
      width: 94%;
      padding: 0 3%;
      border-radius: 3px;
      font-size: 14px;
      line-height: 32px;
      &:focus{
        outline: none;
        border: 1px solid #26a2ff;
      }
    }
    input{height: 31px;}
    textarea{
      height: 80px;
      resize: none;
    }
  }
  .append{
    background-color: #f5f7fa;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #dcdfe6;
    border-left: 0;
    font-size: 14px;
    padding: 3px 0;
    border-radius: 4px;
    width: 60px;
    white-space: nowrap;
    height: 24px;
    line-height: 24px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    text-align: center
  }
</style>
<style>
    .autocomplete .el-input input{
        line-height: 32px;
        height: 32px;
    }
</style>